import * as actions from "../action.constants";

const requestControllers = (pageUrl = "", trackPromise = true) => ({
  type: actions.REQUEST_CONTROLLERS_SAGA,
  pageUrl,
  trackPromise,
});

const requestTelemetry = (callback) => ({
  type: actions.REQUEST_TELEMETRY,
  callback,
});

const saveSelectedControler = (info) => ({
  type: actions.SAVE_SELECTED_CONTROLLER,
  info,
});

const requestControllerProperties = (trackPromise = false) => ({
  type: actions.REQUEST_SYSTEM_PROPERTIES_SAGA,
  trackPromise,
});

const requestIOTypes = (callback) => ({
  type: actions.REQUEST_IO_TYPES_SAGA,
  callback,
});

const requestSensorList = (payload, callback) => ({
  type: actions.REQUEST_SENSOR_LIST_SAGA,
  payload,
  callback,
});

const requestProbesTypesList = (payload, callback) => ({
  type: actions.REQUEST_PROBES_TYPES_SAGA,
  payload,
  callback,
});

const requestAvailablePins = (payload, callback) => ({
  type: actions.REQUEST_PINS_LIST_SAGA,
  payload,
  callback,
});

const requestCreateProbe = (payload, callback) => ({
  type: actions.REQUEST_CREATE_PROBE_SAGA,
  payload,
  callback,
});

const requestSummaryData = (trackThisPromise = false) => ({
  type: actions.REQUEST_SYSTEM_SUMMARY_DATA_SAGA,
  trackThisPromise,
});

const requestSummarySensorData = (payload, trackThisPromise = true) => ({
  type: actions.REQUEST_INVENTORY_SENSOR,
  payload,
  trackThisPromise,
});

const storeSummarySensorData = (payload) => ({
  type: actions.STORE_INVENTORY_SENSOR,
  payload,
});

const requestSensorCalibrationData = (payload) => ({
  type: actions.REQUEST_INVENTORY_SENSOR_CALIBRATE_CMDS,
  payload,
});

const storeSensorCalibrationData = (payload) => ({
  type: actions.STORE_INVENTORY_SENSOR_CALIBRATE_CMDS,
  payload,
});

const runSensorCalibration = (payload) => ({
  type: actions.RUN_CALIBRATION,
  payload,
});

const requestSensorCalibrationHistoryData = (payload, trackThisPromise = true) => ({
  type: actions.REQUEST_INVENTORY_SENSOR_CALIBRATION_HISTORY,
  payload,
  trackThisPromise,
});

const storeSensorCalibrationHistoryData = (payload) => ({
  type: actions.STORE_INVENTORY_SENSOR_CALIBRATION_HISTORY,
  payload,
});

const requestSensorDetails = (payload, callback, routeAction) => ({
  type: actions.REQUEST_SENSOR_DETAILS_SAGA,
  payload,
  callback,
  routeAction,
});

const updateSensorDetailsConfig = (payload, callback) => ({
  type: actions.REQUEST_UPDATE_SENSOR_DETAILS_SAGA,
  payload,
  callback,
});

const sendDeleteSensorRequest = (data, callback) => ({
  type: actions.REQUEST_DELETE_SENSOR_SAGA,
  payload: data,
  callback,
});

const resetLimitSensorRequest = (data, callback) => ({
  type: actions.REQUEST_RESET_LIMIT_SENSOR,
  payload: data,
  callback,
});

const acknowledgeOnOff = (sensorId) => ({
  type: actions.REQUEST_ACKNOWLEDGE_POWER,
  payload: sensorId,
});

const requestTestFeed = (payload) => ({
  type: actions.TEST_FEED_SAGA,
  payload,
});

const requestAddSlugFeed = (payload, callback) => ({
  type: actions.ADD_SLUG_FEED_SAGA,
  payload,
  callback,
});

const requestSystemLogs = (pageUrl, params) => ({
  type: actions.REQUEST_SYSTEM_LOGS_SAGA,
  pageUrl,
  params,
});

const requestSensorSummary = (payload) => ({
  type: actions.REQUEST_SENSOR_SUMMARY_DATA,
  payload,
});

const requestSensorSummaryReset = () => ({
  type: actions.REQUEST_SENSOR_SUMMARY_RESET_DATA,
});

const sendEditControllerModalData = (data, callback) => ({
  type: actions.SEND_EDIT_CONTROLLER_DATA_SAGA,
  payload: data,
  callback,
});

const requestAnalogBank = () => ({
  type: actions.REQUEST_ANALOG_BANK,
});

const sendAnalogBankData = (data, callback) => ({
  type: actions.SEND_ANALOG_BANK,
  payload: data,
  callback,
});

const requestFavourites = () => ({
  type: actions.REQUEST_SYSTEM_FAVOURITES,
});

const requestFavourite = () => ({
  type: actions.REQUEST_SYSTEM_FAVOURITE,
});

const sendFavourite = (data) => ({
  type: actions.SEND_SYSTEM_FAVOURITE,
  payload: data,
});

const requestSnapshot = (url) => ({
  type: actions.REQUEST_SNAPSHOT,
  pageUrl: url,
});

const storeSnapshot = (payload) => ({
  type: actions.STORE_SNAPSHOT,
  payload,
});

const resetController = (callback = () => {}) => ({
  type: actions.RESET_CONTROLLER,
  callback,
});

const requestCategories = () => ({
  type: actions.GET_CATEGORIES,
});

const storeCategories = (categories) => ({
  type: actions.STORE_CATEGORIES,
  payload: categories,
});

const requestSensorTypeList = (payload, callback) => ({
  type: actions.REQUEST_SENSORTYPES_SAGA,
  payload,
  callback,
});

const requestSensorGroupsByCategory = (payload, callback) => ({
  type: actions.REQUEST_SENSORGROUPS_BYCATEGORY,
  payload,
  callback,
});

const requestSensorGroupList = (callback) => ({
  type: actions.REQUEST_SENSORGROUPS_SAGA,
  callback,
});

const sensorGroupTypeSelected = (payload, callback1, callback2) => ({
  type: actions.REQUEST_SENSORGROUPTYPE_SELECTED_SAGA,
  payload,
  callback1,
  callback2,
});

const updateSensorGroupType = (payload, callback) => ({
  type: actions.UPDATE_SENSORGROUPTYPE,
  payload,
  callback,
});

const requestControllersWithActiveAlert = (pageUrl) => ({
  type: actions.REQUEST_CONTROLLERS_WITH_ACTIVE_ALERT,
  pageUrl,
});
const requestControllerSensorData = (callback = () => {}) => ({
  type: actions.REQUEST_CONTROLLER_SENSOR_DATA,
  callback,
});
const resetControllerSensorData = () => ({
  type: actions.RESET_CONTROLLER_SENSOR_DATA,
});

export {
  requestControllers,
  requestTelemetry,
  saveSelectedControler,
  requestControllerProperties,
  requestIOTypes,
  requestSensorList,
  requestAvailablePins,
  requestProbesTypesList,
  requestCreateProbe,
  requestSummaryData,
  requestSensorDetails,
  updateSensorDetailsConfig,
  sendDeleteSensorRequest,
  resetLimitSensorRequest,
  acknowledgeOnOff,
  requestTestFeed,
  requestAddSlugFeed,
  requestSystemLogs,
  requestSensorSummary,
  requestSensorSummaryReset,
  sendEditControllerModalData,
  requestAnalogBank,
  sendAnalogBankData,
  requestFavourite,
  sendFavourite,
  requestFavourites,
  requestSnapshot,
  storeSnapshot,
  requestSummarySensorData,
  requestSensorCalibrationData,
  runSensorCalibration,
  requestSensorCalibrationHistoryData,
  storeSensorCalibrationData,
  storeSensorCalibrationHistoryData,
  storeSummarySensorData,
  resetController,
  requestCategories,
  storeCategories,
  requestSensorTypeList,
  requestSensorGroupsByCategory,
  requestSensorGroupList,
  sensorGroupTypeSelected,
  updateSensorGroupType,
  requestControllersWithActiveAlert,
  requestControllerSensorData,
  resetControllerSensorData,
};
